import { Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid my-3" }
const _hoisted_2 = {
  id: "account-settings-tabs",
  class: "nav nav-tabs nav-tabs-primary",
  role: "tablist"
}
const _hoisted_3 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Cards")
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Accounts")
const _hoisted_9 = { class: "tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#filter-bar-content" })),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'user-settings'},
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'user-cards'},
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: { name: 'user-accounts'},
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}